import React from 'react';
import { Input } from '@h2/ui';
import { Field } from '@h2/types';

interface TextInputProps {
  field: Field;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export const TextInput: React.FC<TextInputProps> = ({ field, value, onChange, error }) => {
  return (
    <Input
      id={field.id}
      type="text"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={field.placeholder}
      className={error ? 'border-red-500' : ''}
    />
  );
};
